//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import constant from '~/const';
import chatImage from './chatImage.vue';

export default {
  components: { chatImage },

  props: {
    value: { type: Boolean, default: false },
    step: { type: Number, default: 0 },
    sortedByDateChatMessages: { type: Array, default: () => [] },
  },
  data() {
    return {
      showImageError: false,
      constant,
    };
  },
  computed: {
    model: {
      get() {
        const { value } = this;
        return value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  methods: {
    setImageError() {
      this.showImageError = true;
    },

    prepareTextArray(text) {
      if (!text) return [];
      const preparedText = text.replaceAll('<br>', '');
      const arr = preparedText.split(/<b>|<\/b>/);
      if (preparedText.indexOf('<b>') === 0) arr.unshift('');
      return arr;
    },
  },
};

